<template>
  <div class="essay-page">
    <div class="title-img">
      <div class="title-img-check" v-if="checkFlag">
        <img :src="resourceUrl(essayObj.titleImg,'title')">
      </div>
      <div class="title-img-edit" v-else @click="uploadClick">
        <div class="upload-text">+点击上传头图</div>
        <img class="upload-img" v-if="essayObj.titleImg" :src="resourceUrl(essayObj.titleImg,'title')">
      </div>
    </div>

    <el-upload
        v-show="false"
        ref="titleUpload"
        :action="baseUrl + '/common/upload'"
        :show-file-list="false"
        :on-success="handleAvatarSuccess"

    >
    </el-upload>

    <div class="essay-main">
      <div class="essay-main-left"></div>
      <div class="essay-main-center">
        <div class="menu">
          <div class="menu-title el-icon-paperclip">
            内容标签：
          </div>
          <div class="menu-title">
            <el-checkbox-group v-model="checkedTagList" :disabled="checkFlag" @change="tagListChange">
              <el-checkbox v-for="(tag,index) in tagList" :label="tag" :key="index">{{ tag }}</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        <div class="title">
          <template v-if="checkFlag">
            <h1>{{ essayObj.title }}</h1>
          </template>
          <template v-else>
            <el-input v-model="essayObj.title">
              <template slot="prepend">标题：</template>
            </el-input>
          </template>
        </div>
        <div class="title-info">
          <div class="icon-author">
            <img :src="essayObj.userAvatar ? resourceUrl(essayObj.userAvatar,'avatar') : resourceUrl($store.getters.avatar,'avatar')">
            <span>{{essayObj.nickName ? essayObj.nickName : $store.getters.nickName}}</span>
          </div>
          <div class="time">{{ essayObj.createTime ? essayObj.createTime : currentTime }}</div>
        </div>
        <div class="content">
          <mavon-editor previewBackground="#fff" v-if="checkFlag" ref="markdown" v-model="content" :subfield="false" :defaultOpen="'preview'" :editable="false" :toolbarsFlag="false"/>
          <mavon-editor v-else ref="markdown" v-model="content" @imgAdd="imgUpload" @imgDel="imgDelete"/>
          <div class="content-foot" v-if="checkFlag">
            <div class="detail">
              <div class="like" @click="likeClick">
                <img class="img" src="@/static/icon/appreciate.svg">
                <div class="number">{{ essayObj.likeNum }}</div>
              </div>
              <div class="messge">
                <img class="img" src="@/static/icon/message.svg">
                <div class="number">{{ essayObj.messageNum }}</div>
              </div>
            </div>
          </div>

<!--          <div class="separator"></div>-->
          <div class="comment" v-if="checkFlag">
            <h-comment :business-id="essayObj.id" :type="'1'" :row="5" @success="commentAdd"></h-comment>
            <h-comment-list :comment-list="essayObj.commentList"></h-comment-list>
          </div>
        </div>
      </div>
      <div class="essay-main-right"></div>
    </div>

    <h-float-icon v-if="!editPermission" :check-flag="true" @checkClick="checkClick"></h-float-icon>
    <h-float-icon v-if="editPermission && !editFlag" :edit-flag="true" :check-flag="true" @editClick="editClick" @checkClick="checkClick"></h-float-icon>
    <h-float-icon v-if="editPermission && editFlag" :edit-flag="true" :check-flag="true" :save-flag="true" @editClick="editClick" @checkClick="checkClick" @saveClick="saveClick"></h-float-icon>
  </div>
</template>

<script>
import { mavonEditor } from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
import { getEssayInfo, hasPermiCheck, saveEssay } from '@/api/essayApi'
import {fileUpload} from '@/api/commonApi'
import HFloatIcon from '@/page/components/h-float-icon'
import { likeAdd } from '@/api/likeApi'
import HComment from '@/page/components/h-comment'
import HCommentList from '@/page/components/h-comment-list'

export default {
  name: 'index',
  components: { HCommentList, HComment,  HFloatIcon, mavonEditor },
  data() {
    return {
      editPermission: false,
      editFlag: false,
      checkFlag: true,
      currentState:'check',
      title: '',
      content:'',
      essayObj:{},
      drawerFlag:true,
      footShowFlag:false,
      baseUrl: process.env.VUE_APP_BASE_API,
      checkedTagList:[],
      tagList:['日常','编程'],
    }
  },
  computed: {
    currentTime() { // 定义一个计算属性currentTime
      return new Date().toLocaleString(); // 返回当前日期和时间字符串
    }
  },
  mounted() {
    this.init();
  },
  watch:{
    'content'(newValue, oldValue) {
    },
    '$route.query.essayId'(newValue, oldValue) {
      if(newValue != oldValue){
        this.init();
      }
    }
  },
  methods: {
    init(){
      this.clearData();
      const query = this.$route.query;
      if(query.type && (query.type == 'add' || query.type == 'edit')){
        //默认进入新增/修改模式
        this.editInit(query);
      }else {
        //查看模式
       this.dataInit(query);
      }
    },
    /**
     * 数据加载
     */
    dataInit(query){
      if(query && query.essayId){
        this.essayObj.id = query.essayId;
        this.getEssay();
      }else {
        this.$nextTick(()=>{
          this.$router.push({ path: '/404'});
        })
      }
    },
    /**
     * 修改模式开始
     */
    editInit(query){
      if(this.$store.getters.loginFlag){
        this.editFlag = true
        this.checkFlag = false
        if(query.type == 'edit'){//修改
          //判断是否有权限
          hasPermiCheck({id:query.essayId,operateUserId:this.$store.getters.userId}).then(res =>{
            if(res && res.data){
              this.editPermission = true;
              this.dataInit(query);
            }else {
              this.$router.push({ path: '/401'});
            }
          })
        }else if(query.type == 'add'){
          this.editPermission = true;
        }
      }else {
        //没有权限的时候直接跳转401
        this.$nextTick(()=>{
          this.$router.push({ path: '/401'});
        })
      }
    },
    getEssay(){
      const $this = this;
      getEssayInfo($this.essayObj.id).then(res =>{
        if(res && res.code == 200){
          $this.essayObj = res.data;
          //标签格式转码
          if($this.essayObj && $this.essayObj.tags){
            $this.checkedTagList = this.essayObj.tags.split(',');
          }
          //内容
          if(res.data.essayContentVo && res.data.essayContentVo.content){
            $this.content = res.data.essayContentVo.content;
          }
          //判断是否有修改权限
          if($this.$store.getters.userId == $this.essayObj.userId){
            $this.editPermission = true;
          }
        }else if(res.code == 404){
          this.$router.push({ path: '/404'});
          $this.$message.error(res.msg)
        }
      })
    },
    // 绑定@imgAdd event
    imgUpload(pos, $file){
      // 第一步.将图片上传到服务器.
      const $this = this;
      let fromData = new FormData();
      fromData.append('file', $file);
      fileUpload(fromData).then((res) => {
        if(res && res.code == 200){
          // $this.$refs.markdown.$img2Url(pos, res.url);
          $this.$refs.markdown.$img2Url(pos, $this.baseUrl + res.fileName);
        }else {
          alert("上传失败")
        }
      })
    },
    imgDelete(){

    },
    saveEssay(){
      const $this = this;

      //内容赋值
      if($this.essayObj.essayContentVo){
        $this.essayObj.essayContentVo.content = $this.content;
      }else {
        $this.essayObj.essayContentVo = {
            content:$this.content
        };
      }

      saveEssay($this.essayObj).then(res =>{
        if(res && res.code == 200){
          $this.$message.success("保存成功")
          $this.checkClick()
        }
      })
    },
    editClick(){
      this.editFlag = true;
      this.checkFlag = false;
      this.currentState = 'edit'
    },
    checkClick(){
      this.checkFlag = true;
      this.editFlag = false;
      this.currentState = 'check'
    },
    saveClick(){
      this.saveEssay();
    },
    handleAvatarSuccess(res, file){
      this.$set(this.essayObj,"titleImg",res.fileName);
    },
    footHideCLick(){
      this.footShowFlag = false;
    },
    /**
     * 头图上传点击事件
     */
    uploadClick(){
      const titleUpload = this.$refs.titleUpload;
      titleUpload.$refs["upload-inner"].handleClick();
    },
    /**
     * 数据清空
     */
    clearData(){
      this.essayObj = {};
      this.content = '';
      this.checkedTagList = [];
    },
    /**
     * 内容标签修改
     */
    tagListChange(checkList){
      if(checkList){
        this.essayObj.tags = checkList.join(',')
      }
    },
    commentAdd(content,businessId){
      this.init();
    },
    likeClick(){
      let like = {};
      like.type = '1';
      like.businessId = this.essayObj.id;
      likeAdd(like).then(res =>{
        if(res){
          if(res.code == 200){
            this.essayObj.likeNum ++;
            this.$message.success("点赞成功");
          }else if (res.code == 401){
            this.$message.warning("请登录");
          }
        }else {
          this.$message.warning("已经点过赞啦");
        }
      })
    }
  },


}
</script>

<style scoped>
@import '../../static/css/essay.css';

.content{
  overflow: hidden;
}
</style>
